import React from 'react';

import { IconButton } from '@components/button/Button';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import Modal from '@layouts/modal/Modal';
import { getLocalStorageItem } from '@utils/storage';

import AddCallModal from './AddCallModal';
import AddEventModal from './AddEventModal';
import AddTaskModal from './AddTaskModal';

import { getTypeLabel } from '../../constants/leadActivity';
import { ActivityModalProps } from '../../types/leadActivity';

const ActivityModal: React.FC<ActivityModalProps> = ({
  onClose,
  type,
  onSubmit,
  initialData = {},
  leadId,
  analyticsData
}) => {
  const renderModalContent = () => {
    switch (type) {
      case 'task':
        return (
          <AddTaskModal
            onClose={onClose}
            onSubmit={onSubmit}
            initialData={initialData}
            leadId={leadId}
            analyticsData={analyticsData}
          />
        );
      case 'event':
        return (
          <AddEventModal
            onClose={onClose}
            onSubmit={onSubmit}
            initialData={initialData}
            leadId={leadId}
            analyticsData={analyticsData}
          />
        );
      case 'call':
        return (
          <AddCallModal
            onClose={onClose}
            onSubmit={onSubmit}
            initialData={initialData}
            leadId={leadId}
            analyticsData={analyticsData}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      isOpen
      onCancel={onClose}
      className="max-h-[90vh] w-139 overflow-y-auto rounded-xl bg-white shadow-lg"
    >
      <div className="flex items-center justify-between rounded-t-xl border-b border-gray-200 p-6 pb-3">
        <h2 className="text-xl font-medium text-gray-900">
          {initialData.id ||
          getLocalStorageItem(LOCAL_STORAGE_KEYS.ACTIVITY_DETAILS)?.data?.id
            ? 'Edit'
            : 'Add'}{' '}
          {getTypeLabel(type)}
        </h2>
        <IconButton
          iconName="close"
          variant="transparent"
          buttonSize="small"
          handleClick={onClose}
          className="rounded-full hover:bg-gray-100"
        />
      </div>

      <div className="space-y-4 pt-6">{renderModalContent()}</div>
    </Modal>
  );
};

export default ActivityModal;
